import { useQuery } from "@apollo/react-hooks";
import { REAL_ESTATE_GALLERY_QUERY } from "./Queries";
import { RealEstateGallery, RealEstateGalleryVariables } from "./graphql/RealEstateGallery";

export const GetRealEstateGallery = (realEstateId) =>
  useQuery<RealEstateGallery, RealEstateGalleryVariables>(REAL_ESTATE_GALLERY_QUERY, {
    variables: { realEstateId }
  });
